import type { SlideDef } from "@/engine/types";
import { contentSeo } from "./01-content";
import { ecommerceSeo } from "./02-ecommerce";
import { longTailSeo } from "./03-longtail";
import { gscDemo } from "./04-gsc-demo";
import { nicheKeywords } from "./05-niche-keywords";

export const slides: SlideDef[] = [
  contentSeo,
  ecommerceSeo,
  longTailSeo,
  gscDemo,
  nicheKeywords,
];
